export const getMemberById = id => state => {
  return state.members.find(({ id: memberId }) => memberId === id);
};

export const getMembersWhoHaveNotTeammateYet = state => {
  const teammateWorkspaces = state.workspaces.filter(({ isPersonal, isGroup }) => !isPersonal && !isGroup);
  const teammates = teammateWorkspaces
    .map(({ users }) => users.find(({ id }) => id !== state.user.id))
    .filter(teammate => teammate);

  return state.members.filter(({ id }) => !teammates.find(teammate => teammate.id === id) && id !== state.user.id);
};
